export enum ErrorCodes {
    fail_to_reach_identity_provider = 'fail_to_reach_identity_provider',
    fail_to_reach_api = 'fail_to_reach_api',
    fail_to_get_me = 'fail_to_get_me',
    unknown = 'unknown'
}

export enum ErrorMessages {
    fail_to_reach_identity_provider = 'Impossible de communiquer avec iam.fr.clara.net.',
    fail_to_reach_api = 'Impossible de communiquer avec l\'API SynApps. <b>Vérifiez que vous êtes bien connecté au VPN.</b>',
    fail_to_get_me = 'Impossible de charger les données de l\'utilisateur.',
    unknown = 'Erreur inconnue.'
}

export interface Error {
    matcher: RegExp;
    message: string;
}

export const enumCodesErrors = {
    400: 'Requête invalide',
    403: 'Accès non autorisé',
    404: 'Donnée non trouvée',
    408: 'La récupération des données a pris trop de temps',
    500: 'Erreur interne',
    503: 'Accès au service impossible',
    504: 'Timeout : accès au service impossible',
    UNKNOWN: 'Erreur inconnue'
};
